export const RemoveFilterSVG = ({ fill }: { fill: string }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.54157 5.17467C5.4749 7.65801 8.33324 11.333 8.33324 11.333V15.4997C8.33324 16.4163 9.08324 17.1663 9.9999 17.1663C10.8461 17.1663 11.5502 16.5273 11.6535 15.708H11.4582C10.4227 15.708 9.58324 14.8685 9.58324 13.833C9.58324 12.7975 10.4227 11.958 11.4582 11.958H11.6666V11.333C11.6666 11.333 14.5249 7.65801 16.4582 5.17467C16.8832 4.62467 16.4916 3.83301 15.7916 3.83301H4.1999C3.50824 3.83301 3.11657 4.62467 3.54157 5.17467ZM10.8332 13.833C10.8332 14.2932 11.2063 14.6663 11.6666 14.6663H18.3332C18.7935 14.6663 19.1666 14.2932 19.1666 13.833C19.1666 13.3728 18.7935 12.9997 18.3332 12.9997H11.6666C11.2063 12.9997 10.8332 13.3728 10.8332 13.833Z"
        fill={fill}
      />
    </svg>
  );
};
